/**
 * @generated SignedSource<<99b28e817df2c4c831a57cf228541ed6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GetPostSummarizerQuery$variables = {
  postId: string;
};
export type GetPostSummarizerQuery$data = {
  readonly unified: {
    readonly ai: {
      readonly getPostSummarizer: {
        readonly __typename: "UnifiedAiPostSummarizerResult";
        readonly code?: string | null | undefined;
        readonly identifier?: string | null | undefined;
        readonly keyPoints?: ReadonlyArray<string>;
        readonly sentiment?: string;
        readonly summary?: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GetPostSummarizerQuery = {
  response: GetPostSummarizerQuery$data;
  variables: GetPostSummarizerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "postId",
    "variableName": "postId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keyPoints",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentiment",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetPostSummarizerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedAiQuery",
            "kind": "LinkedField",
            "name": "ai",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getPostSummarizer",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "UnifiedAiPostSummarizerResult",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetPostSummarizerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedAiQuery",
            "kind": "LinkedField",
            "name": "ai",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getPostSummarizer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "UnifiedAiPostSummarizerResult",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c40e85c75a3ba71bab8ae4c214a63634",
    "id": null,
    "metadata": {},
    "name": "GetPostSummarizerQuery",
    "operationKind": "query",
    "text": "query GetPostSummarizerQuery(\n  $postId: String!\n) {\n  unified {\n    ai {\n      getPostSummarizer(postId: $postId) {\n        __typename\n        ... on UnifiedQueryError {\n          code\n          identifier\n        }\n        ... on UnifiedAiPostSummarizerResult {\n          __typename\n          keyPoints\n          sentiment\n          summary\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c95c64e4b824bcf0495212d0950b7d06";

export default node;
